import { NewRelicBrowser } from './NewRelicBrowser';

export class NewRelicBrowserFactory {
  constructor(accountInfoAttributes) {
    if (NewRelicBrowserFactory.instance) {
      return NewRelicBrowserFactory.instance;
    }

    this.accountInfoAttributes = accountInfoAttributes;
    this.newRelicWrappers = new Map();
    NewRelicBrowserFactory.instance = this;
  }

  getNewRelicWrapper(featureName) {
    return this.newRelicWrappers.get(featureName);
  }

  registerNewRelicWrapper(featureName, nrWrapper) {
    this.newRelicWrappers.set(featureName, nrWrapper);
  }

  getAccountNo() {
    return this.accountInfoAttributes.getAccountNo();
  }

  create({ featureName, config, customAttributes = {} }) {
    if (!config || typeof window === 'undefined') {
      return null;
    }

    if (!this.getNewRelicWrapper(featureName)) {
      const getCustomAttributes = () => ({
        accountNo: this.getAccountNo(),
        ...customAttributes,
      });
      const newRelicWrapper = new NewRelicBrowser(config, getCustomAttributes);
      this.registerNewRelicWrapper(featureName, newRelicWrapper);
    }

    return this.getNewRelicWrapper(featureName);
  }
}

NewRelicBrowserFactory.instance = null;
